module.exports = __webpack_public_path__ + "static/img/nav9.62e6999e.svg";